import script from "./earnAndDeductForm.vue?vue&type=script&setup=true&lang=js"
export * from "./earnAndDeductForm.vue?vue&type=script&setup=true&lang=js"

import "./earnAndDeductForm.vue?vue&type=style&index=0&id=6a5ebb89&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6a5ebb89"]])

export default __exports__